
import React from 'react';
import { Card } from './ui/card';
import { cn } from '@/lib/utils';

interface GameCardProps {
  title: string;
  duration: string;
  description: string;
  onClick: () => void;
  className?: string;
}

const GameCard = ({ title, duration, description, onClick, className }: GameCardProps) => {
  return (
    <Card
      className={cn(
        "group cursor-pointer transition-all duration-300 hover:scale-[1.02] active:scale-[0.98] bg-cream/80 hover:bg-cream p-6",
        className
      )}
      onClick={onClick}
    >
      <div className="space-y-2">
        <div className="inline-flex items-center rounded-full bg-sage/10 px-3 py-1 text-sm text-sage-dark">
          {duration}
        </div>
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        <p className="text-sm text-gray-600">{description}</p>
      </div>
    </Card>
  );
};

export default GameCard;
